import { Box, Typography } from '@mui/material';
import {
  AutocompleteInput,
  RaRecord,
  ReferenceInput,
  ReferenceInputProps,
  useInput,
  useRecordContext,
} from 'react-admin';
import { RoleName } from 'types/role.types';

export const UserInput: React.FC<Omit<ReferenceInputProps, 'reference'>> = ({
  source,
  label,
  ...rest
}) => {
  const { field: organizationId } = useInput({ source: 'organization' });
  const optionText = <OptionRenderer />;
  const inputText = (option: RaRecord) =>
    `${option?.firstName} ${option?.lastName}`;
  return (
    <ReferenceInput
      source={source}
      reference="users"
      sort={{ field: 'lastName', order: 'ASC' }}
      filter={{
        roles: [RoleName.Advisor, RoleName.Mandator],
        ...(organizationId ? { organizations: [organizationId.value] } : {}),
      }}
      {...rest}
    >
      <AutocompleteInput
        label={label}
        variant="outlined"
        filterToQuery={(query: string) => ({ search: query })}
        source={source}
        optionText={optionText}
        inputText={inputText}
      />
    </ReferenceInput>
  );
};

const OptionRenderer = () => {
  const record = useRecordContext();
  return (
    <Box>
      {record?.firstName} {record?.lastName}
      <Typography variant="caption">{` - organization '${record.organization.name}'`}</Typography>
    </Box>
  );
};
